

















module.exports =
  props: ['clients']




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home/clients.vue